import { Row } from '@stenajs-webui/core';
import { RadioButtonWithLabel } from '@stenajs-webui/forms';

interface CargoGoodsRadioRowProps {
  disabled: boolean;
  onChange: (value: boolean) => void;
  value: boolean;
}

export function CargoGoodsRadioButtons({ value, onChange, disabled }: CargoGoodsRadioRowProps) {
  const onValueChange = (value: string) => {
    onChange(value === 'empty');
  };

  return (
    <Row gap={2}>
      <RadioButtonWithLabel
        label={'Loaded'}
        disabled={disabled}
        checked={!value}
        value={'loaded'}
        onValueChange={onValueChange}
      />
      <RadioButtonWithLabel
        label={'Empty'}
        value={'empty'}
        disabled={disabled}
        checked={value}
        onValueChange={onValueChange}
      />
    </Row>
  );
}
